import { IFieldMediaImage, IFieldMediaImageTopPagesWebpBo } from '../../interfaces/field-media-image';
import { IRteText } from '../../interfaces/rte-text';

export const TypeNameBlockWidgetFormTopPage = 'ParagraphTopPageWidgetForm';

export interface IWidgetFormTopPageBO {
  __typename: typeof TypeNameBlockWidgetFormTopPage;
  id?: number;
  title?: string;
  description?: IRteText;
  mediaCover?: IFieldMediaImageTopPagesWebpBo;
  enableTrustPilot?: boolean;
  formTitle?: string;
  formDescription?: string;
  workType?: WidgetFormWorkType;
}
export interface IWidgetFormTopPage {
  __typename: typeof TypeNameBlockWidgetFormTopPage;
  id?: number;
  title?: string;
  description?: IRteText;
  mediaCover?: IFieldMediaImage;
  enableTrustPilot?: boolean;
  formTitle?: string;
  formDescription?: string;
  workType?: WidgetFormWorkType;
}

export enum WidgetFormWorkType {
  AtticsInsulation = 'attics_insulation', // Isolation des combles
  WallInsulation = 'wall_insulation', // Isolation des murs
  AirWaterHeatPump = 'air_water_heat_pump', // Pompe à chaleur Air/Eau
  AirAirHeatPump = 'air_air_heat_pump', // Pompe à chaleur Air/Air
  WoodBoiler = 'wood_boiler', // Chaudière à bois
  FireplaceInsert = 'fireplace_insert', // Insert
  WoodStove = 'wood_stove', // Poêle à granulés
  DoubleGlazing = 'double_glazing', // Fenêtres
  ThermodynamicWaterHeater = 'thermodynamic_water_heater', // Chauffe-eau thermodynamique
}
